import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { ADMIN_CONSTANT } from 'src/app/app.model';

@Component({
  selector: 'app-profile-menu-list',
  templateUrl: './profile-menu-list.component.html',
  styleUrls: ['./profile-menu-list.component.scss'],
})
export class ProfileMenuListComponent implements OnInit {
  @Output() profileAction: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onChangePWD(): void {
    this.profileAction.emit(ADMIN_CONSTANT.USER_PROFILE_CHANGE_PWD);
  }

  onSwitch(): void {
    this.profileAction.emit(ADMIN_CONSTANT.USER_PROFILE_SWITCH);
  }

  onLogout(): void {
    this.profileAction.emit(ADMIN_CONSTANT.USER_PROFILE_ACTION);
  }
}
